import { render, staticRenderFns } from "./MaterialsRight.vue?vue&type=template&id=5737034a&scoped=true&"
import script from "./MaterialsRight.vue?vue&type=script&lang=js&"
export * from "./MaterialsRight.vue?vue&type=script&lang=js&"
import style0 from "./MaterialsRight.vue?vue&type=style&index=0&id=5737034a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5737034a",
  null
  
)

export default component.exports